/* eslint-disable @typescript-eslint/no-explicit-any */
import { simpleGlobalState } from '@pbk-web/state';
import type { ThemeStateProps } from '@pbk-web/types';

import themes from './ThemeDefinitions';

const DEFAULT_THEME_NAME = 'playbook';

export const currentTheme = (import.meta as any).env['VITE_THEME']
  ? themes[((import.meta as any).env['VITE_THEME'] as string).trim().toLowerCase() || DEFAULT_THEME_NAME]
  : themes[DEFAULT_THEME_NAME]; // white label approach

export const useTheme = simpleGlobalState<ThemeStateProps | null>(currentTheme || null);
